module.exports = __webpack_public_path__ + "static/media/delete.fd56d8ff.svg";